module.exports = __webpack_public_path__ + "static/intro-background-0f3ff8338d1c2fa382de7118a6262c26.jpg";